export const getLiveTitle = (content: any, formSubtitle: boolean) => {
    let title = content?.title
    let subtitle

    if (!content) return { title, subtitle }

    if (content?.isLive?.()) {
        title = content.serieTitle ? content.serieTitle : content.title
        const seasonNumber = content.seasonNumber && `S${content.seasonNumber}`
        const episodeNumber = content.episodeNumber && `E${content.episodeNumber}`
        const number = [seasonNumber, episodeNumber].filter(Boolean).join(' ')
        const episodeTitle = content.serieTitle && content.title

        if(formSubtitle) {
            subtitle = [number, episodeTitle].filter(Boolean)
            subtitle = subtitle.join(' - ')
        }

        if (content.serieTitle && !formSubtitle) {
            title = [title, number].join(' - ')
        }
    }

    return { title, subtitle }
}